import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  formattedLanguageName,
  KeyValue,
  Row,
} from '@folio/stripes-components';
import { useIntl } from 'react-intl';

function LanguageFieldView({ fieldValues, locale, data }) {
  const { name, label } = fieldValues;
  const fieldLabel = label.find((field) => field.locale === locale)?.value;
  const intl = useIntl();

  const formatLanguages = (languages = []) => {
    return languages
      .map((languageCode) => formattedLanguageName(languageCode, intl, locale))
      .join(', ');
  };

  return (
    <Row>
      <Col xs={12}>
        <KeyValue label={fieldLabel} value={formatLanguages(data[name])} />
      </Col>
    </Row>
  );
}

LanguageFieldView.propTypes = {
  fieldValues: PropTypes.object,
  locale: PropTypes.string,
  data: PropTypes.object,
};

export default LanguageFieldView;
